jQuery(window).konami({
    code: [38, 40, 37, 39], // up down left right
    //code: [38, 40], // up up down down left left right right
    cheat: function () {

        $('head').append('<link rel="stylesheet" href="/typo3conf/ext/ni_assets/Resources/Public/Css/credits.css" type="text/css" />');

        var names = [
            'Thomas Brandl', 'Andreas Gloggengiesser',
            'Marc Eilhard', 'Konrad Gmurek', 'Jascha Dachtera', 'Björn Schmitt',
            'Michael Sohn', 'Joachim Landesvatter',
            'Fabian Kurz', 'Christoph Zahn',
            'Stanislav Kopp', 'Marcus Hanisch', 'Stanislav Filippov', 'Daniel Wedewardt'
        ];

        function shuffle(array) {
            var currentIndex = array.length, temporaryValue, randomIndex;
            while (0 !== currentIndex) {
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            return array;
        }

        var lines = ['<span>MADE WITH ♥ BY</span>'].concat(shuffle(names)).concat(['<span>&copy; NATIVE INSTRUMENTS GMBH</span>']);

        var html = '<div class="credits"><p style="background: #fff"><img src="/typo3conf/ext/ni_assets/Resources/Public/Images/ni-logo.png"/></p></div>';

        $.magnificPopup.open({
            items: {
                src: html,
                type: 'inline'
            }
        });

        setTimeout(function () {
            var credits = $('.credits');
            $(lines).each(function (i) {
                var that = this;
                setTimeout(function () {
                    credits.append($('<p class="credits-animation">' + that + '</p>'));
                }, 1000 * i);
            });
        }, 500);

    }
});